export const buildEmployeeCycleProgressId = (
  employeeId?: number,
  cycleId?: string
): string | undefined => {
  if (!employeeId || !cycleId) return
  return `${employeeId}-${cycleId}`
}
